export default "__VITE_ASSET__Bps8rTyu__"